<template>
	<div class="changeBox">
		<ul>
			<li @click="changeIndex(0,'zh')" :class="{active:indexLi == 0}">中</li>
			<li @click="changeIndex(1,'en')" :class="{active:indexLi == 1}" >En</li>

			<li v-if="indexLi != 1" @click="changeIndex(2,'en')" :class="{active:indexLi == 2}">中 <img v-if="indexLi == 2 || indexLi == 1" src="./img/change1.png" alt=""><img v-else src="./img/change.png" alt=""> En</li>
			<li v-else class="nocheck">中 <img v-if="indexLi == 2 || indexLi == 1" src="./img/change1.png" alt=""><img v-else src="./img/change.png" alt=""> En</li>

			<li v-if="indexLi != 0" @click="changeIndex(3,'zh')" :class="{active:indexLi == 3,nocheck:indexLi == 0 }">En <img v-if="indexLi == 3 || indexLi == 0" src="./img/change1.png" alt=""><img v-else src="./img/change.png" alt=""> 中</li>
			<li v-else class="nocheck">En <img v-if="indexLi == 3 || indexLi == 0" src="./img/change1.png" alt=""><img v-else src="./img/change.png" alt=""> 中</li>

		</ul>
   
		
    <textarea v-if="type == 1" ref=textarea class="text" v-model="msg" placeholder="境外出险记录到”城市“即可" @input="submitInput"></textarea>
    <textarea v-else ref=textarea class="text" v-model="msg" :placeholder="palceholder" @input="submitInput"></textarea>
		<p style="display: none;">{{languageIndex}}</p>
	</div>
 
</template>

<script>
	import { changeLanguage } from '@/views/axios/api.js';
	import constants from "@/util/constants.js";
	export default{
		data(){
			return{
				indexLi:0,
				msg:this.value,
				token:JSON.parse(window.localStorage.getItem("data")).data,
				palceholder:'请输入',
				isChina:true,
				zhText:'',//中文
				enText:'',//英文
				nowString:'',
				msgBtn:true,
				num:0,
        type:this.type
			}
		},
		props:['value','changeText','btn','type'],
		methods:{
      handlePushKeyword(event){
        if (event.keyCode === 13) {
          event.preventDefault(); // 阻止浏览器默认换行操作
          this.handleSendMessage(); // 发送文本
          return false;
        }
      },

			changeIndex(index,status){
				this.indexLi =index;
				this.$refs.textarea.focus()
				if(index == 0){
					this.palceholder='请输入';
					this.isChina=true;
					this.msg=this.zhText;
				}else if(index == 1){
					this.palceholder='Please enter';
					this.isChina=false;
					this.msg=this.enText;
				}else if(index == 2){
					this.isChina=false;
					this.changeFun(index,status);
				}else if(index == 3){
					this.isChina=true;
					this.changeFun(index,status);
				}
			},
			changeFun(index,status){
				if(this.msg == undefined || this.msg == '') return this.indexLi = 0
				var data={
					token:this.token,
					query:this.msg,
					lang:status
				}
				changeLanguage(data)
				.then(res => {
					console.log(this.isChina)
					if(this.isChina){
						this.zhText=res.data.obj;
						this.msg=this.zhText;
						this.indexLi=0;
					}else{
						this.enText=res.data.obj;
						this.msg=this.enText;
						this.indexLi=1
					}

				})
				.catch(err => {
					console.log(err)
				})

			},
			submitInput(){
				this.msgBtn=false
				if(this.isChina){
					this.zhText=this.msg;
					// this.enText='';
					this.indexLi=0;
				}else{
					this.enText=this.msg;
					// this.zhText='';
					this.indexLi=1;
				}
				this.nowString =`<zh-CN>${this.zhText}</zh-CN><en-US>${this.enText}</en-US>`
				this.$emit('input', this.nowString)
			},
			setBtn(){
				this.msgBtn=true
			}
		},
		computed: {
			languageIndex() {
				this.num = this.$store.state.language
				return this.$store.state.language
			}
		},
		watch:{
			num(){
				this.indexLi=this.num;
				if(constants.setTxt(this.changeText,'zh')){
					this.zhText=constants.setTxt(this.changeText,'zh')
					this.enText=constants.setTxt(this.changeText,'en')
				}
				if(this.num == 0){
					this.changeIndex(0,'zh')
				}else{
					this.changeIndex(1,'en')
				}
			},
			msg(newVal){
				if(this.msgBtn) return
				this.nowString =`<zh-CN>${this.zhText}</zh-CN><en-US>${this.enText}</en-US>`
				this.$emit('input',this.nowString)
			},
			changeText(){
				if(!this.msgBtn) return
				this.msg=this.changeText;
        console.log(this.changeText)
				if(!constants.setTxt(this.changeText,'zh')) return this.msg=this.zhText=this.changeText
				if(this.num == 0){
					this.msg=this.zhText=constants.setTxt(this.changeText,'zh')
				}else{
					this.msg=this.enText=constants.setTxt(this.changeText,'en')
				}
			},
      btn(){
        console.log(this.btn);
        this.msg=this.changeText;
        if(!constants.setTxt(this.changeText,'zh')) return this.msg=this.zhText=this.changeText
        if(this.num == 0){
        	this.msg=this.zhText=constants.setTxt(this.changeText,'zh')
        }else{
        	this.msg=this.enText=constants.setTxt(this.changeText,'en')
        }
      }
		}
	}
</script>

<style scoped="scoped">
.changeBox ul{overflow: hidden;}
.changeBox ul li{float: left;padding: 0 10px;border: 1px solid #d9ddde;height: 25px;line-height: 25px;margin-right: 10px;cursor: pointer;border-radius: 2px;}
.changeBox ul li.active{background-color: #00abfa;color: white;}
.text{white-space: pre-line; display: block;margin-top: 10px;border: 1px solid #d9ddde;width: calc(100% - 22px);min-height: 50px;border-radius: 5px;outline: none;padding: 10px;resize: none;color: #666;}
.changeBox ul li.nocheck{background-color: #ccc;color: white;cursor: not-allowed;}
</style>



// WEBPACK FOOTER //
// src/components/common/changeLange.vue